import { useRecoveryPasswordStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { Button, Modal } from '@shared/widgets';
import SuccessIcon from '@assets/images/auth/auth_success_ico.svg';

export const SuccessRecoveryModal = () => {
  const { success, clear } = useRecoveryPasswordStore();

  const { navigate } = useRouteHook();

  const closeHandler = () => {
    clear();
    navigate(RoutePaths.login.onNavigate());
  };

  return (
    <Modal isOpen={success!} onClose={closeHandler}>
      <SuccessIcon className='mx-auto mb-4 hidden max-md:block' />
      <h2 className='mb-12 text-center font-[Prata] text-[28px] font-medium text-[#0f0f11] max-md:mb-6 max-md:text-lg'>
        We will be in touch shortly
      </h2>
      <p className='max-md:text-[#4c4c4c80]'>
        Please note a member of our team will be in touch with you in the next 2 hours to inform you of your full log in details securely.
      </p>
      <p className='max-md:text-[#4c4c4c80]'>If you need urgent assistance please contact the call centre team on the number below.</p>
      <div className='mt-4 mb-8 max-md:mx-6 max-md:mt-4 max-md:rounded-lg max-md:bg-[#d7c29a1a] max-md:p-2'>
        <p className='text-[#000]'>24-hour phone support:</p>
        <p className='text-[#000]'>+44-203-151-7000 / +800-800-00-700</p>
      </div>
      <Button className='mx-auto w-[159px] max-md:w-full' onClick={closeHandler}>
        Ok
      </Button>
    </Modal>
  );
};
